namespace $.$$ {

	type $shm_hitalama_map_page_arrow_widgets_box = {
		left: number
		top: number
		width: number
		height: number
	}

	export class $shm_hitalama_map_page_arrow_widgets extends $.$shm_hitalama_map_page_arrow_widgets {

		widget_box( widget: $.$shm_hitalama_map_widget_float ): $shm_hitalama_map_page_arrow_widgets_box {
			return {
				left: widget.left(),
				top: widget.top(),
				width: widget.width(),
				height: widget.height(),
			}
		}

		@ $mol_mem
		points() {
			return this.edge_points(
				this.widget_box( this.from_widget() ),
				this.widget_box( this.to_widget() ),
			)
		}

		edge_points(
			from: $shm_hitalama_map_page_arrow_widgets_box,
			to: $shm_hitalama_map_page_arrow_widgets_box,
		) {
			const from_center = [ from.left + from.width / 2, from.top + from.height / 2 ] as const
			const to_center = [ to.left + to.width / 2, to.top + to.height / 2 ] as const
			const dx = to_center[0] - from_center[0]
			const dy = to_center[1] - from_center[1]

			if( Math.abs( dx ) > Math.abs( dy ) ) {
				return {
					from: [
						dx >= 0 ? from.left + from.width : from.left,
						from_center[1],
					],
					to: [
						dx >= 0 ? to.left : to.left + to.width,
						to_center[1],
					],
				}
			}

			return {
				from: [
					from_center[0],
					dy >= 0 ? from.top + from.height : from.top,
				],
				to: [
					to_center[0],
					dy >= 0 ? to.top : to.top + to.height,
				],
			}
		}

		from_pos() {
			return this.points().from
		}

		to_pos() {
			return this.points().to
		}

	}

}
